import VueRouter from "vue-router";
import { ILoginData } from "@/api/moudules/login.types";
import { autoLogin } from "./global";
import qs from 'qs'
import { gStore } from "@/global";
import { loginCounter } from "./storage";
class TokenManager {
    static TOKEN_KEY = 'token'
    getValue() {
        return localStorage.getItem(TokenManager.TOKEN_KEY)
    }
    setValue(value: string) {
        localStorage.setItem(TokenManager.TOKEN_KEY, value)
    }
    clear() {
        localStorage.removeItem(TokenManager.TOKEN_KEY)
    }
}
export const tokenManager = new TokenManager()

export function markAuth(data: ILoginData) {    
    tokenManager.setValue(data.token)
    localStorage.setItem('user', data.userName) // 保存用户到本地会话
}

export function cleanAuth() {
    loginCounter.clear()
    gStore.value.commit('clearStates')
    tokenManager.clear()
    localStorage.removeItem('user') // 保存用户到本地会话
}

export function goToLogin(router: VueRouter) {
    cleanAuth()
    // 自动登录只需要重新刷新就可以获取token    
    if (autoLogin || headerQueryAccount()) {
        console.log('自动登录获取token!')
        window.location.reload()
        return
    }
    router.replace({
        name: 'login'
    })
}


export function headerQueryAccount() {
    let search = location.search
    let searchParams = qs.parse(search, {
        ignoreQueryPrefix: true
    })
    let account = searchParams['account']
    return account
}

export function cleanQueryAndReload() {
    location.search = ''        
}
